module.exports = __webpack_public_path__ + "img/cash.svg";